export const GUARANTEES_APPLICATION_AM_REVIEW_MODE = 'am-review';
export const GUARANTEES_APPLICATION_MANUAL_TASK_QUERY_PARAM = 'manualTask';
const withCounterparty = (path: string, contragentId?: string | null, reviewMode?: string) => {
  const params = new URLSearchParams();
  if (contragentId) params.set('contragentId', String(contragentId));
  if (reviewMode) params.set('reviewMode', reviewMode);
  const query = params.toString();
  return query ? `${path}?${query}` : path;
};
const applicationPath = (id: string | number, suffix = '') =>
  `/guarantees/administrator/application/${id}${suffix}`;
export const buildGuaranteesApplicationPath = (
  id: string | number,
  contragentId?: string | null,
  _admin = true,
  reviewMode?: string
) => withCounterparty(applicationPath(id), contragentId, reviewMode);
export const buildGuaranteesApplicationStep3Path = (
  id: string | number,
  contragentId?: string | null,
  _admin = true
) => withCounterparty(applicationPath(id, '/step3'), contragentId);
export const buildGuaranteesApplicationAmApprovalLetterPath = (
  id: string | number,
  contragentId?: string | null,
  _admin = true
) => withCounterparty(applicationPath(id, '/step4'), contragentId);
export const buildGuaranteesApplicationAmApprovalLetterManualSignPath = (
  id: string | number,
  contragentId?: string | null
) => withCounterparty(applicationPath(id, '/am-approval-letter-manual-sign'), contragentId);
export const buildGuaranteesApplicationAmApprovalLetterClientSignedPath = (
  id: string | number,
  contragentId?: string | null
) => withCounterparty(applicationPath(id, '/am-approval-letter-client-signed'), contragentId);
export const buildGuaranteesApplicationInternalApprovalLetterPath = (
  id: string | number,
  contragentId?: string | null,
  type = 'udbtf'
) => withCounterparty(applicationPath(id, `/internal-approval-letter/${type}`), contragentId);
export const buildGuaranteesApplicationUdbtfGuaranteeScanCopyPath = (
  id: string | number,
  contragentId?: string | null
) => withCounterparty(applicationPath(id, '/udbtf-guarantee-scan-copy'), contragentId);
export const buildGuaranteesApplicationUsapokApprovalPath = (
  id: string | number,
  contragentId?: string | null
) => withCounterparty(applicationPath(id, '/usapok-approval'), contragentId);
export const buildGuaranteesApplicationUakdoControlPath = (
  id: string | number,
  contragentId?: string | null
) => withCounterparty(applicationPath(id, '/uakdo-control'), contragentId);
export const buildGuaranteesApplicationUakdoControllerControlPath = (
  id: string | number,
  contragentId?: string | null
) => withCounterparty(applicationPath(id, '/uakdo-controller-control'), contragentId);
export const isGuaranteesApprovalLetterElectronicExecutionCheck = (application: {
  executionCheck?: unknown;
  executionChecks?: Record<string, unknown>;
}) => {
  const value =
    application.executionChecks?.applicationForm ??
    application.executionChecks?.executionCheck ??
    application.executionCheck;
  return String(value ?? '')
    .toUpperCase()
    .includes('ELECTRONIC');
};
export const isManualAmApprovalLetterInProgress = (
  application:
    { executionCheck?: unknown; executionChecks?: Record<string, unknown> } | null | undefined,
  isManualTask = false
) => isManualTask || !isGuaranteesApprovalLetterElectronicExecutionCheck(application ?? {});
